import instance from './axiosEnv';

const contactSupport = ( newMail) => {
    return instance.post('/contactSupport', newMail)
}

const mailAPI = { 
    contactSupport 
}
export default mailAPI;